<div class="container">
  <form [formGroup]="form">

    <div class="card flex-auto">
      <div class="px-6 py-4 border-b flex items-center header-title">
        <h2 class="title m-0">Edit recipe</h2>
        <div class="flex-end">
          <button [matMenuTriggerFor]="languageFormMenu" mat-icon-button type="button" align="end">
            <mat-icon svgIcon="{{iconFormFlag}}"></mat-icon>
          </button>
          <mat-menu #languageFormMenu="matMenu" overlapTrigger="false">
            <button mat-menu-item (click)="changeFormLanguage('it')">
              <mat-icon svgIcon="flag:italy"></mat-icon>
              <span>Italiano</span>
            </button>
            <button mat-menu-item (click)="changeFormLanguage('en')">
              <mat-icon svgIcon="flag:united-states"></mat-icon>
              <span>English</span>
            </button>
          </mat-menu>
        </div>
      </div>

      <div class="px-6 py-4 flex flex-col">

        <div class="card px-6 py-4 flex flex-col subCards" *ngIf="formLang=='it'">

          <mat-form-field>
            <mat-label>{{"RECIPES_LIST.TITLE" | translate}} {{"GLOBAL.ITA" | translate}}</mat-label>
            <input matInput formControlName="nome_it" required>
          </mat-form-field>

          <mat-form-field class="flex-auto">
            <mat-label>{{"RECIPES_LIST.TITLE" | translate}}</mat-label>
            <mat-select formControlName="category">
              <mat-option></mat-option>
              <mat-option [value]="option.key" *ngFor="let option of category">{{ option.description }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="flex-auto">
            <mat-label>Tags</mat-label>
            <mat-select formControlName="tags" multiple>
              <mat-option *ngFor="let tag of availableTags" [value]="tag">{{ tag }}</mat-option>
            </mat-select>
          </mat-form-field>

          <div class="flex flex-col sm:flex-row sm:gap-4">
            <mat-form-field class="flex-auto">
              <mat-label>{{"RECIPES_LIST.INGREDIENTS" | translate}}</mat-label>
              <input type="text" matInput [formControlName]="'ingredients'" [matAutocomplete]="auto"
                (keyup)="searchIng()" (focus)="searchIng()">
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
                <mat-option *ngFor="let item of ingredients" [value]="item">
                  {{item.i18nName[translate.currentLang]}} ({{item.unit[translate.currentLang]}})
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <button class="btn-add-ingredient" (click)="!showCreateIngredient ? showCreateIngredient = true : showCreateIngredient = false">
              <span *ngIf="!showCreateIngredient">{{"RECIPES_LIST.CREATE_INGREDIENT" | translate}}</span>
              <span *ngIf="showCreateIngredient">cancel</span>
            </button>
          </div>
          <div class="chip-container">
            <span *ngFor="let item of selectedIngredients; let k = index" class="chip">
              <mat-icon svgIcon="mat:arrow_back" *ngIf="k > 0" (click)="moveIngredient(k,'left')"></mat-icon>
              {{ item.i18nName[translate.currentLang] }} ({{item.unit[translate.currentLang]}})
              <button (click)="removeSelected(item)">✖</button>
              <mat-icon svgIcon="mat:arrow_forward" *ngIf="k < (selectedIngredients.length-1)" (click)="moveIngredient(k,'right')"></mat-icon>
            </span>
          </div>
          <div class="add-ingredient-container" *ngIf="showCreateIngredient">
            <p class="mb-4">{{"RECIPES_LIST.CREATE_INGREDIENT" | translate}}</p>
            <div class="flex flex-col sm:flex-row sm:gap-4">
              <mat-form-field class="flex-auto">
                <mat-label>{{"RECIPES_LIST.NAME_INGREDIENT" | translate}} {{"GLOBAL.ITA" | translate}}</mat-label>
                <input matInput formControlName="ingredient_name_it" required>
              </mat-form-field>
              <mat-form-field class="flex-auto">
                <mat-label>{{"RECIPES_LIST.NAME_INGREDIENT" | translate}} {{"GLOBAL.ENG" | translate}}</mat-label>
                <input matInput formControlName="ingredient_name_en" required>
              </mat-form-field>
              <mat-form-field class="flex-auto">
                <mat-label>{{"RECIPES_LIST.UNIT" | translate}}</mat-label>
                <mat-select formControlName="ingredient_unit">
                  <mat-option [value]="option" *ngFor="let option of units">{{ option[translate.currentLang]}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <button class="btn-add-ingredient" (click)="addIngredient()">{{"RECIPES_LIST.ADD_INGREDIENT" | translate}}</button>
          </div>

          <div class="mt-4 mb-4">
            <h2 class="title mb-2">{{"NEW-SUB.DESC" | translate}} {{"GLOBAL.ITA" | translate}}</h2>
            <quill-editor formControlName="desc_it" [styles]="{ flex: '1 1 auto' }"></quill-editor>
          </div>
        </div>


        <!-- EN FORM -->
        <div class="card px-6 py-4 flex flex-col subCards" *ngIf="formLang=='en'">

          <mat-form-field>
            <mat-label>{{"RECIPES_LIST.TITLE" | translate}} {{"GLOBAL.ENG" | translate}}</mat-label>
            <input matInput formControlName="nome_en" required>
          </mat-form-field>
          <mat-form-field class="flex-auto">
            <mat-label>{{"RECIPES_LIST.CATEGORY" | translate}}</mat-label>
            <mat-select formControlName="category">
              <mat-option></mat-option>
              <mat-option [value]="option.key" *ngFor="let option of category">{{ option.description }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="flex-auto">
            <mat-label>Tags</mat-label>
            <mat-select formControlName="tags" multiple>
              <mat-option *ngFor="let tag of availableTags" [value]="tag">{{ tag }}</mat-option>
            </mat-select>
          </mat-form-field>

          <div class="flex flex-col sm:flex-row sm:gap-4">
            <mat-form-field class="flex-auto">
              <mat-label>{{"RECIPES_LIST.INGREDIENTS" | translate}}</mat-label>
              <input type="text" matInput [formControlName]="'ingredients'" [matAutocomplete]="auto"
                (keyup)="searchIng()" (focus)="searchIng()">
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
                <mat-option *ngFor="let item of ingredients" [value]="item">
                  {{item.i18nName[translate.currentLang]}} ({{item.unit[translate.currentLang]}})
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <button class="btn-add-ingredient" (click)="!showCreateIngredient ? showCreateIngredient = true : showCreateIngredient = false">
              <span *ngIf="!showCreateIngredient">{{"RECIPES_LIST.CREATE_INGREDIENT" | translate}}</span>
              <span *ngIf="showCreateIngredient">cancel</span>
            </button>
          </div>
          <div class="chip-container">
            <span *ngFor="let item of selectedIngredients; let k = index" class="chip">
              <mat-icon svgIcon="mat:arrow_back" *ngIf="k > 0" (click)="moveIngredient(k,'left')"></mat-icon>
              {{ item.i18nName[translate.currentLang] }} ({{item.unit[translate.currentLang]}})
              <button (click)="removeSelected(item)">✖</button>
              <mat-icon svgIcon="mat:arrow_forward" *ngIf="k < (selectedIngredients.length-1)" (click)="moveIngredient(k,'right')"></mat-icon>
            </span>
          </div>
          <div class="add-ingredient-container" *ngIf="showCreateIngredient">
            <p class="mb-4">{{"RECIPES_LIST.CREATE_INGREDIENT" | translate}}</p>
            <div class="flex flex-col sm:flex-row sm:gap-4">
              <mat-form-field class="flex-auto">
                <mat-label>{{"RECIPES_LIST.NAME_INGREDIENT" | translate}} {{"GLOBAL.ITA" | translate}}</mat-label>
                <input matInput formControlName="ingredient_name_it" required>
              </mat-form-field>
              <mat-form-field class="flex-auto">
                <mat-label>{{"RECIPES_LIST.NAME_INGREDIENT" | translate}} {{"GLOBAL.ENG" | translate}}</mat-label>
                <input matInput formControlName="ingredient_name_en" required>
              </mat-form-field>
              <mat-form-field class="flex-auto">
                <mat-label>{{"RECIPES_LIST.UNIT_INGREDIENT" | translate}}</mat-label>
                <mat-select formControlName="ingredient_unit">
                  <mat-option [value]="option" *ngFor="let option of units">{{ option[translate.currentLang]}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <button class="btn-add-ingredient" (click)="addIngredient()">{{"RECIPES_LIST.ADD_INGREDIENT" | translate}}</button>
          </div>

          <div class="mt-4 mb-4">
            <h2 class="title mb-2">{{"NEW-SUB.DESC" | translate}} {{"GLOBAL.ENG" | translate}}</h2>
            <quill-editor formControlName="desc_en" [styles]="{ flex: '1 1 auto' }"></quill-editor>
          </div>
        </div>
          <img class="mt-4" style="width: 100px;" [src]="environment.node+'/get-recipe-image/'+recipe._id" alt="">
          <input type="file" class="mt-4" (change)="onFileSelected($event)" accept="image/*">
        <div class="bottoni">
          <button (click)="confirmClose()" class="m-4">{{"GLOBAL.CLOSE" | translate}}</button>
          <button mat-raised-button (click)="submit()"
            class="m-4 bottone-viola">{{"GLOBAL.EDIT" | translate}}</button>
        </div>
      </div>
    </div>
  </form>
</div>
